import {
  RELOAD_PROJECT_PALETTES
} from '../actions/types';

const INITIAL_STATE = {
  reload: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RELOAD_PROJECT_PALETTES:
      return { ...state, reload: action.payload.reload };

    default:
      return { ...state };
  }
}
